import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { ROLE_PERMISSIONS } from "../utils/rolePermissions";

export const usePermissions = () => {
  const role = useSelector((state) => state.user.role);

  const permissions = useMemo(() => ROLE_PERMISSIONS[role] || [], [role]);

  const hasPermission = useCallback(
    (permission) => {
      if (!permission) return true;

      return permissions.includes(permission);
    },
    [permissions]
  );

  return {
    role,
    permissions,
    hasPermission,
  };
};
